export default "__VITE_ASSET__vABbgBb3__"